// Tag any element whose direct text is a sale-related label so the CSS blink kicks in.
// Uses XPath so it works regardless of element type (<a>, <summary>, <magnet-element>, etc.)

(function () {
  function markSaleLinks() {
    var snapshot;
    try {
      snapshot = document.evaluate(
        "//*[not(self::script) and not(self::style)]" +
        "[normalize-space(translate(text()," +
        "'ABCDEFGHIJKLMNOPQRSTUVWXYZ'," +
        "'abcdefghijklmnopqrstuvwxyz'))='on sale' " +
        "or normalize-space(translate(text()," +
        "'ABCDEFGHIJKLMNOPQRSTUVWXYZ'," +
        "'abcdefghijklmnopqrstuvwxyz'))='sale' " +
        "or normalize-space(translate(text()," +
        "'ABCDEFGHIJKLMNOPQRSTUVWXYZ'," +
        "'abcdefghijklmnopqrstuvwxyz'))='sales']",
        document, null, XPathResult.ORDERED_NODE_SNAPSHOT_TYPE, null
      );
    } catch (e) {
      console.warn('[sale-blink] XPath failed:', e);
      return 0;
    }

    var tagged = 0;
    for (var i = 0; i < snapshot.snapshotLength; i++) {
      var el = snapshot.snapshotItem(i);
      if (!el || el.classList.contains('sale-blink')) continue;
      // Skip hidden / off-screen duplicates (themes often render text twice for hover transitions)
      if (el.offsetParent === null) continue;
      var cs = window.getComputedStyle(el);
      if (cs.visibility === 'hidden' || cs.display === 'none' || parseFloat(cs.opacity) === 0) continue;
      el.classList.add('sale-blink');
      tagged++;
    }
    if (tagged > 0) console.log('[sale-blink] tagged', tagged, 'element(s)');
    return tagged;
  }

  function init() {
    markSaleLinks();
    var observer = new MutationObserver(function () { markSaleLinks(); });
    observer.observe(document.body, { childList: true, subtree: true });
    setTimeout(function () { observer.disconnect(); }, 8000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  if (window.Shopify && window.Shopify.designMode) {
    document.addEventListener('shopify:section:load', markSaleLinks);
    document.addEventListener('shopify:section:reorder', markSaleLinks);
  }
})();
